import React, { useContext, useEffect, useState } from "react";

// Styling
import "../../Styles/MainPage.scss";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

// Logout function
import { logOut } from "../../helperFunctions";

// To get Weaviate's current state
import { weaviateStateGetter } from "../../helperFunctions";

// Component imports
import NavbarIcons from "./NavbarIcons";
import WeaviateStateDisplay from "./WeaviateStateDisplay";
import GeneralModal from "./GeneralModal";

//to push browser history
import { useHistory } from "react-router-dom";

// Material UI stuff
import { TertiaryButton } from "../../materialUiComponents";

const NavbarRight = () => {
  // global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  //to open and close log out modal
  const [logOutModal, setLogOutModal] = useState(false);

  // Controls the weaviate display
  const [isWeaviateConnected, setIsWeaviateConnected] = useState(false);

  //to use history
  const history = useHistory();

  const openLogOutModal = () => {
    setLogOutModal(true);
  };

  //to close the modal
  const closeModal = () => {
    setLogOutModal(false);
  };

  const logOutHandler = () => {
    logOut(setState, state, history);
  };

  useEffect(() => {
    weaviateStateGetter(state, setIsWeaviateConnected);
  }, [state]);

  return (
    <div className="__navbarRight">
      <WeaviateStateDisplay isWeaviateConnected={isWeaviateConnected} />
      <NavbarIcons />
      <TertiaryButton id="#logOutButton" onClick={openLogOutModal}>
        Log Out
      </TertiaryButton>
      <GeneralModal
        text=" Are you sure you'd like to log out of the Weaviate Console ?"
        closeModal={closeModal}
        cancelFunction={closeModal}
        actionFunction={logOutHandler}
        open={logOutModal}
        actionText="Log Out"
        cancelText="Cancel"
        modalDescription="Log Out modal dialog"
        title="Log Out?"
        actionButtonId="logOutModalButton"
      />
    </div>
  );
};

export default NavbarRight;
